import React from 'react';

export const ContactUsView = () => {
    return (<>
        Contact Us
    </>)
};